module.exports = __webpack_public_path__ + "static/media/cursorWhite.328a5774.png";